import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedCurrencyContainer from '../../../../../components/formatted-currency/container';
import { ArchiveContext } from '../../archive-context';
import { messages } from '../../messages';
import style from '../../style.module.less';

const ArchiveShippingTotalColumn = ({ archiveId }) => {
  const { archives } = useContext(ArchiveContext);
  const archiveShippingCost = archives[archiveId]?.shippingCost;
  return (
    <div className={classnames(style['item-cell'], style['number-cell'])}>
      <FormattedCurrencyContainer currencyCode={archiveShippingCost?.code} value={archiveShippingCost?.value} />
    </div>
  );
};

ArchiveShippingTotalColumn.propTypes = {
  archiveId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.archiveShippingTotal} />,
  id: 'archiveShippingTotal',
  render: ArchiveShippingTotalColumn,
};
